<template>
  <div class="flex -mx-3">
    <div class="w-64 px-3" />
    <div class="flex-1 px-3 capitalize">
      {{ $te('name') ? $t('name') : 'name' }}
      /
      {{ $te('description') ? $t('description') : 'description' }}
    </div>
    <div class="w-24 px-3 text-right capitalize">
      {{ $te('price') ? $t('price') : 'price' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataIteratHeader',
};
</script>
